import * as React from 'react';
// @ts-ignore
import Parcel from 'single-spa-react/lib/esm/parcel';
import { mountRootParcel } from 'single-spa';
import { parse } from 'url';
import { compose } from 'recompose';
import { passApplication } from '@unitedtraders/application-bootstrapper';
import { translate } from '../utils/translateUtils';

const enhance = compose(translate, passApplication);

const DepositModalView = ({ application: { authorization, settings }, lng, baseUrl, onClose }) => {
  const appConfig = {
    graphqlGateway: settings.get('graphqlGateway'),
    utcomGateway: {
      rest: {
        url: parse(settings.get('grpcGateway').url)
      }
    },
    utexWallet: {
      url: settings.get('utexWalletsUrl')
    }
  };

  return (
    <Parcel
      config={() => import('@unitedtraders/deposit-microfrontend')}
      mountParcel={mountRootParcel}
      locale={lng}
      getTokens={() => authorization.getTokens()}
      appConfig={appConfig}
      baseUrl={baseUrl}
      closeModal={onClose}
      onSuccessButtonClick={() => (window.location.href = '/investments')}
    />
  );
};

export const DepositModal = enhance(DepositModalView);



// WEBPACK FOOTER //
// ./src/components/DepositModal.jsx